import React from 'react'
import { Link } from 'react-router-dom';

function Card({ props }) {
  let proj = props.casa
  const isVendida = proj[0] === 'No' || proj[13]?.toLowerCase().includes('vendida');
  return (
    <div className='modern-card'>
      <div className='modern-card-image-container'>
        <img 
          src={(proj[5]) ? `https://drive.google.com/thumbnail?id=${proj[5].split('/')[5]}` : 'http://yodesarrollo.mx/img/logo_large.png'} 
          alt={proj[2]}
          className='modern-card-image'
        />
        {isVendida && (
          <div className='modern-card-badge'>Vendida</div>
        )}
      </div>
      
      <div className='modern-card-content'>
        <div className='modern-card-price-section'>
          {isVendida ? (
            <>
              <p className='modern-card-price'>Vendida</p>
              <p className='modern-card-price-label'>&nbsp;</p>
            </>
          ) : (
            <>
              <p className='modern-card-price'>{proj[13]}</p>
              <p className='modern-card-price-label'>Precio actual</p>
            </>
          )}
        </div>

        <div className='modern-card-info'>
          <h3 className='modern-card-title'>{proj[2]}</h3>
          <p className='modern-card-location'>{proj[3]}, {proj[1]}</p>
        </div>

        <div className='modern-card-features'>
          <div className='modern-card-feature'>
            <i className='fas fa-vector-square'></i>
            <span>{proj[11]} m²</span>
          </div>
          <div className='modern-card-feature'>
            <i className='fas fa-home'></i>
            <span>{proj[12]} m²</span>
          </div>
        </div>

        <Link to={{ pathname: proj[2], state: { id: proj[2], content: props.content } }} className='modern-card-button'>
          Ver propiedad
        </Link>
      </div>
    </div>
  )
}

export default Card